(function () {
    'use strict';

    // Defines a Iframe to be user with SSO Logout.
    // Usage:
    //        <sso-iframe client="client" />
    // Creates:
    //  <iframe height="0" width="0" frameborder="0" stc="client.logOutUrl"></iframe>
    angular.module('app.sso').directive('ssoIframe', ssoiFrame);

    /* @ngInject */
    function ssoiFrame($timeout) {

        var directive = {
            restrict: 'E',
            replace: true,
            scope: {
                application: '=',
                callback: '='
            },
            //required in 1.3+ with controllerAs
            bindToController: true,
            controller: controller,
            controllerAs: 'vm',
            link: link,
            template: '<iframe class="logoutIframe" height="0" width="0" frameborder="0"></iframe>'
        };
        return directive;

        function controller() {

        }

        function link(scope, elem) {
            var vm = scope.vm;
            vm.application.status = 'loading';

            // Load the iframe.
            var frame = angular.element(elem[0]);
            frame.bind('load', function () {
                scope.$apply(function () {
                    if (!vm.application.complete) {
                        vm.application.complete = true;
                        vm.application.status = 'loaded';
                        if (vm.callback){
                            vm.callback();
                        }
                    }
                });
            });
            frame.attr('src', vm.application.LogOutURL);

            // Mark error if it takes longer than 10 seconds.
            $timeout(function () {
                if (!vm.application.complete) {
                    vm.application.complete = true;
                    vm.application.status = 'error';
                    if (vm.callback){
                            vm.callback();
                        }
                }
            }, 10000);
        }
    }
})();
